module.exports = __webpack_public_path__ + "f248dc5e.png";